import {FormPageInput, FormPageState} from 'types/formPage';

import {composeReducers, createDeleteWithKeyReducer, createUpdateWithKeyReducer} from '../@reducers';

import initialState from './initialState';

const NAME = '@formPage';

// reducers
const getReducer = createUpdateWithKeyReducer<FormPageInput>(NAME, initialState);
const deleteReducer = createDeleteWithKeyReducer<FormPageInput>(NAME, initialState);
const changeFormIdReducer = (
    state: FormPageState = initialState,
    action = null
) => {
    switch (action.type) {
        case '@formPage/UPDATED_ID': {
            const {prevId, newId} = (action?.payload || {}) as any
            if (prevId === newId || !newId) return state
            const prevVal = state.data[prevId] || {}
            const newState = {
                ...state,
                isLoading: false,
                isInitLoading: false,

                data: {
                    ...state.data,
                    ...{[newId]: {...prevVal, id: newId}},
                }
            };
            delete newState.data[prevId]
            return newState
            break;
        }
        default:
            return state;
    }
};
export const formsPagesReducer = composeReducers<FormPageState>(initialState)(getReducer, deleteReducer, changeFormIdReducer);

export default formsPagesReducer;
